@if (!cacheLoaded) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="provision-list-header">
  <h1 class="page-title">Provisions</h1>

  <div class="filter-container">
    <mat-button-toggle-group (change)="userChangedFilter($event)" multiple="true">
      <mat-button-toggle value="Owner" [checked]="isFilterActive(MyWorkFilter.Owner)">
        I Own
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <span class="provision-count">{{ filteredProvisions.length }} provisions</span>
</div>

<div class="table-container">
  <table mat-table [dataSource]="filteredProvisions" class="provisions-table">

    <ng-container matColumnDef="provName">
      <th mat-header-cell *matHeaderCellDef>Provision</th>
      <td mat-cell *matCellDef="let p">{{ p.provName || '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="contract">
      <th mat-header-cell *matHeaderCellDef>Contract</th>
      <td mat-cell *matCellDef="let p">{{ p.contractFriendlyName || p.contractNum || '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="requiredAction">
      <th mat-header-cell *matHeaderCellDef>Required Action</th>
      <td mat-cell *matCellDef="let p">{{ p.requiredAction || '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="actionDate">
      <th mat-header-cell *matHeaderCellDef>Action Date</th>
      <td mat-cell *matCellDef="let p">{{ p.actionDate || '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let p">
        @if (p.actionCompleted) {
          <mat-icon class="status-icon completed">check_circle</mat-icon>
        } @else {
          <mat-icon class="status-icon pending">schedule</mat-icon>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"
        class="provision-row" (click)="openProvision(row)"></tr>
  </table>

  @if (cacheLoaded && filteredProvisions.length === 0) {
    <p class="empty-state">No provisions are assigned to you.</p>
  }
</div>
